export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-thumb-15fea2c10b176febdb6ba8ad937272a7.png";